import { create } from 'zustand';
import { AiEmailAssistantForm } from '@/schemas/ai-email-assistant';

interface EmailAssistantStore {
  formData: AiEmailAssistantForm;
  setFormData: (data: Partial<AiEmailAssistantForm>) => void;
  resetForm: () => void;
}

export const defaultFormData: AiEmailAssistantForm = {
  messageType: '',
  donorContext: '',
  organizationContext: '',
  pastConversations: ''
};

export const useEmailAssistantStore = create<EmailAssistantStore>(set => ({
  formData: defaultFormData,
  setFormData: data =>
    set(state => ({
      formData: { ...state.formData, ...data }
    })),
  resetForm: () => set({ formData: defaultFormData })
}));
